var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"background-color":"#000000"}},[(_vm.isHarmonys)?_c('myheader',{attrs:{"headTitle":"扫一扫"}}):_vm._e(),_c('div',{staticClass:"scancode all_text_center",attrs:{"id":"scancode"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }